export default __webpack_public_path__ + "static/media/596.c5edd0d1.jpg";